import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "router-card" }

import { useRoute } from "vue-router";
import { computed } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'RouterLink',
  props: ["path", "name"],
  setup(__props) {


const route = useRoute();
const routePath = computed(() => route.path);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: __props.path,
      class: _normalizeClass({ 'router-link-exact-active': routePath.value.startsWith(__props.path) })
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.name), 1)
      ]),
      _: 1
    }, 8, ["to", "class"])
  ]))
}
}

})